<template>
  <BaseAlert
    v-if="shouldShowBanner"
    :text="t('treatwell.commission_change_banner.message')"
    color="warning"
    v-test="'commission-change-banner'"
  />
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTreatwellStore } from '@/stores/treatwell';

const { treatwellStatus } = useTreatwellStore();
const { t } = useI18n();
const shouldShowBanner = computed(() => {
  return (
    treatwellStatus.freeCommissionRemainingDays > 0 &&
    treatwellStatus.hasVenue &&
    !treatwellStatus.venuePending
  );
});
</script>
